<template>
  <div class="header">
    <div id="header" class="header-container">
      <div class="header-title-box">
        <div class="h5-switch none">
          <div class="switch-row">—</div>
          <div class="switch-row">—</div>
          <div class="switch-row">—</div>
        </div>

        <a class="header-logo" href="javascript:void(0)" @click="handleToggleTab(1)"></a>
        <a class="company" href="javascript:void(0)" @click="handleToggleTab(1)">潮合科技</a>
        <div class="our-life">
          <a style="color: #fff" href="">助力企业财务数字化建设</a>
        </div>
      </div>

      <div class="header-links-pallet">

        <a href="javascript:void(0)" class="header-link-box" @click="handleToggleTab(item.id)" v-for="(item,index) in title" :key="index">
          <span class="home-door" :class="item.active">{{item.name}}<span class="menu-hot" v-if="item.id==0">下载</span></span>
        </a>
        <div class="header-link-box header-drawer" v-if="this.$store.state.token != '' && this.$store.state.token != null">
          <p class="login-door">
            {{this.$store.state.username}}
            <a style="font-size: 15.6px; margin-left: 10px" href="javascript:void(0)" @click="handLoginOut(6)">退出</a>
          </p>
        </div>

        <div class="header-link-box header-drawer" v-else>
          <p class="login-door">
            <a class="login-btn" href="javascript:void(0)" @click="handleLogin">登录</a>
            <a class="register-btn" href="javascript:void(0)" @click="handleToggleTab(6)">注册</a>
          </p>
        </div>

      </div>
    </div>
  </div>


</template>


<script>
export default {
  name: "",
  props: {
    title:Array
  },
  methods:{
    handleToggleTab(id){
      this.$emit('handleToggleTab', id);
    },
    handleLogin(){
      this.$emit('handleLogin');
    },
    handLoginOut(){

      this.$store.commit('setUserName', '');
      this.$store.commit('setToken', '');

      localStorage.removeItem("user_token");
      localStorage.removeItem("username");

      //退出，跳转到首页
      this.$emit('handleToggleTab', 1);
    }
  }
};
</script>



<style>

.titleCssClass {
    color: gold;
}

.header {
  height: 70px;
  display: block;

}
.header-container {
  width: 100vw;
  height: 70px;
  display: flex;
  background: linear-gradient(to right, #0d5493, #0d5493);
  /* min-width: 800px; */
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  top: 0;
  z-index: 99999;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 10vw;
  -webkit-transition: ease 0.4s;
  transition: ease 0.4s;
}

.header-title-box {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.header-logo {
  width: 50px;
  height: 50px;
  min-width: 35px;
  min-height: 35px;
  margin-right: 2px;
  margin-top: 3px;
  border-radius: 50%;
  background: url("../assets/img/logo2.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}


.company {
  color: #ffffff;
  font-weight: bold;
  font-size: 25px;
  min-width: 100px;
  clear: right;
  display: block;
}
.company:hover {
  color: #ffffff;
}
.our-life {
  display: block;
  clear: both;
  margin-left: 3px;
  margin-top: 4px;
  font-size: 13px;
  padding: 0px 5px 2px 5px;
  margin-top: 7px;
  min-width: 118px;
  background: #c2be9e;
  color: #ffffff;
  border-radius: 2px;
}
.white-link {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
}
.white-link:hover {
  color: #0d5493;
}
.login-container {
  overflow: hidden;
}
.login-container .login-form {
  width: 460px;
  margin: 100px auto;
  border: solid 6px #0d5493;
  background: #ffffff;
  border-radius: 5px;
  padding: 20px 20px 10px 20px;
  overflow: hidden;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}
.login-container .login-form h1 {
  font-size: 20px;
  margin-bottom: 20px;
}
.menu-hot {
  z-index: 10;
  text-align: center;
  margin-left: 0px;
  padding: 3px 5px 3px 5px;
  font-size: 10px;
  font-weight: bold;
  border-radius: 20px;
  verticle-align: middle;
  background-color: red !important;
  border: #c2be9e solid 2px;
}
.attend {
  margin-top: 80px;
  align-items: center;
  width: 100%;
  height: 100%;
  text-align: center;
  padding: 130px 0px 200px 0px;
  font-size: 12px;
}
.attend img {
  width: 100px;
  height: 100px;
  border: solid 1px #cccccc;
  border-radius: 50px;
  margin-bottom: 20px;
}
.attend .text {
  color: #007ddb;
}



.header-container .links-drawer-box {
  width: 30px;
  height: 30px;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: none;
  cursor: pointer;
}

.header-container .links-drawer-box .drawer-line-top {
  width: 16px;
  height: 2px;
  background: #4d4766;
  margin: 3px;
  -webkit-transition: ease 0.2s;
  transition: ease 0.2s;
}

/* .header-container .links-drawer-box .open-top {
  -webkit-transform: rotate(45deg) translateY(1.5px);
  transform: rotate(45deg) translateY(1.5px);
  margin: 0;
  width: 20px;
} */

/* .header-container .links-drawer-box .drawer-line-bottom {
  width: 16px;
  height: 2px;
  background: #4d4766;
  margin: 3px;
  -webkit-transition: ease 0.3s;
  transition: ease 0.3s;
} */
/*
.header-container .links-drawer-box .open-bottom {
  -webkit-transform: rotate(-45deg) translateY(-1.5px);
  transform: rotate(-45deg) translateY(-1.5px);
  margin: 0;
  width: 20px;
} */

/* .header-title {
  margin-left: 15px;
  font-size: 22px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.3);
  margin-bottom: 3px;
  font-family: "Noto Sans SC", sans-serif, "Noto Serif SC", serif;
  letter-spacing: 1px;
  display: none;
} */

/* .header-logo {
  height: 30px;
  padding: 0;
  margin: 0;
}

.header-logo img {
  width: 100%;
  height: 100%;
} */

.header-links-pallet {
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end;
  height: 100%;
  margin-right: 4%;
}

.header-link-box {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 6px;
  padding: 1px;
  height: 100%;
  font-size: 15px;
  font-weight: 400;
  font-family: "microsoft yahei";
  color: #ffffff;
  display: block;
  min-width: 100px;
  font-weight: bold;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
  letter-spacing: 0.6px;
}

.header-links-pallet a:hover {
  color: gold;
}
.header-link-box:nth-child(1){min-width: 120px;}

/* .header-down-open {
  width: 11px;
  height: 6px;
  background: url(../images/header-down-open.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  margin-left: 8px;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
} */

.header-drawer {
  position: relative;
  cursor: pointer;
}

/* .drawer-off {
  position: absolute;
  top: 108px;
  width: 180px;
  left: -100px;
  height: 0;
  padding: 0;
  overflow: hidden;
} */

/* .header-resources-drawer-box {
  background: #322d47;
  border-radius: 5px;
  width: 100%;
  min-height: 50px;
  overflow: hidden;
  margin-top: 41px;
} */

/* .header-resources-drawer-pallet {
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 180px;
  height: 50px;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 16px;
  font-family: PingFang SC;
}

.header-resources-drawer-pallet:hover {
  background: #4d4766;
  color: #ffffff;
} */


.login-door {
  display: block;
  min-width: 135px;
}
.login-door a {
  color: #ffffff;
}
.login-btn,
.register-btn {
  border: solid 1px #ffffff;
  padding: 6px 15px 6px 15px;
  border-radius: 2px;
  color: #ffffff;
  font-size: 13px;
}
.register-btn {
  background: #c2be9e;
  margin-left: 10px;
}

@media screen and (max-width: 768px) {
  .header-links-pallet {
    display: none;
  }
  .header-container .links-drawer-box {
    display: flex;
  }
}

@media screen and (max-width: 568px) {
  .header-container {
    padding: 0px;
  }
  .header-logo {
    display: none;
  }

  #head .tielt-all {
    width: 100vw;
    box-sizing: border-box;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  .h5-head-uls {
    width: 100vw;
    box-sizing: border-box;
    background-color: rgba(247, 248, 252, 0.9);
    position: absolute;
    top: 80px;
    left: 0;
    z-index: 10;
  }
  .h5-head-uls li {
    padding: 20px 0;
    text-align: center;
    font-size: 17px;
    font-weight: 600;
  }
  .h5-head-uls li a {
    display: inline-block;
    width: 100%;
    color: #4d4766;
  }
  .h5-head-hidden {
    overflow: hidden;
    transition: all 0.3s;
  }
  .h5-switch {
    width: 48px;
    position: relative;
    cursor: pointer;
    text-align: center;
    font-weight: bold;
    color: #ffffff;
    margin-top: -5px;
  }
  .switch-row {
    padding: 0px;
    margin: 0px;
    height: 10px;
    width: 50px;
    line-height: 10px;
    font-size: 30px;
  }
}

@media screen and (min-width: 569px) {
  .none {
    display: none !important;
  }
}
</style>